var _style, _path, _g, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "heart-rate_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".heart-rate_svg__st1{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 85.3c-2-12.9 13.5-23.2 25-12.1 0 0-6.1-14-19.9-13.1-7.4.5-14.1 4.9-17.5 11.4-2.2 4.2-3.5 10-1.1 17.3.8 2.6 2.1 5.1 3.7 7.3.6.9 1.2 1.7 1.9 2.5 3.1 3.5 8.9 9.2 14.7 14.1 0 0 14.4 11.8 17.9 19.7 0-10-4.3-20.2-10.8-27.6C34 99.1 26.3 93.6 25 85.3z",
    fill: "var(--color-icon-secondary)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart-rate_svg__XMLID_6107_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart-rate_svg__XMLID_6108_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart-rate_svg__XMLID_6109_",
    className: "heart-rate_svg__st1",
    d: "M85.8 94.5c1-1.7 1.8-3.5 2.5-5.3 2.4-7.2 1.2-13-.9-17.3-3.3-6.6-9.9-11-17.3-11.6-13.8-1.1-20 12.9-20 12.9s-6.1-14-19.9-13.1c-7.5.5-14.2 4.9-17.6 11.4-2.2 4.2-3.5 10-1.1 17.3.8 2.6 2.1 5.1 3.7 7.3.6.9 1.2 1.7 1.9 2.5 3.1 3.5 8.9 9.2 14.7 14.1 0 0 14.4 11.8 17.9 19.7 2.1-4.7 8.2-10.8 12.8-14.9"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.7,
    cy: 98.8,
    fill: "none",
    stroke: "var(--color-text)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    r: 7.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "heart-rate_svg__st1",
    d: "M65.6 84c-7.6 0-13.7 6.1-13.7 13.7M78 109.2l4 2.9c13.2 9.5 31.5.1 31.5-16.1V58.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "heart-rate_svg__st1",
    d: "M130.9 21.5l-1.1-.3c-1.5-.4-2.3-2-1.9-3.5.4-1.5 2-2.4 3.5-2l2.9.8c1.9.5 3.3 2.2 3.4 4.2.4 9.8-.4 37.7-24.2 37.7-23.7 0-24.6-27.9-24.2-37.7.1-2 1.5-3.7 3.4-4.2l2.9-.8c1.5-.4 3.1.5 3.5 2 .4 1.5-.5 3-1.9 3.5l-1.1.3"
  })));
}
export default SvgHeartRate;